import AddWinnerForm from '@/components/Organization/AddWinner/AddWinnerForm';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getAuctionWonList} from '@/store/organization-auction';
import {getCurrentEventSelector} from '@/store/organization-event';
import {defaultPageSize} from '@/utils/constants';
import {ROUTER_URL} from '@/utils/enums';
import {getErrorMessage} from '@/utils/helpers';
import {UserBidService} from '@/utils/services/user-bid.service';
import {Box, useMediaQuery} from '@mui/material';
import {Formik} from 'formik';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import * as Yup from 'yup';

export interface Winner {
  itemNumber: string;
  bidderNumber: string;
  bidAmount: string;
}

export interface FormValuesWinners {
  winners: Winner[];
}

const schema = Yup.object({
  winners: Yup.array().of(
    Yup.object({
      itemNumber: Yup.string().required('Item Number is required'),
      bidderNumber: Yup.string().required('Winning Bidder Number is required'),
      bidAmount: Yup.string().required('Winning Bid Amount is required'),
    })
  ),
});
const initialValues: FormValuesWinners = {
  winners: [
    {
      itemNumber: '',
      bidderNumber: '',
      bidAmount: '',
    },
  ],
};

const AddWinnerPage = ({formRef, isModal, closeModal}: {formRef?: any; isModal?: boolean; closeModal?: any}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const currentEvent = useAppSelector(getCurrentEventSelector);
  const isLaptop = useMediaQuery('(min-width:1200px)');

  const handleAddWinnerSubmit = async (values: FormValuesWinners) => {
    if (!currentEvent?.id) return;

    const results = await Promise.all(
      values.winners.map((winner) =>
        UserBidService.addWinner({
          itemId: Number(winner.itemNumber),
          bidderId: Number(winner.bidderNumber),
          amount: Number(winner.bidAmount),
          eventId: currentEvent.id,
        })
          .then(() => ({status: 'success'} as const))
          .catch((error) => {
            toast.error(getErrorMessage(error));
            return {status: 'error' as const};
          })
      )
    );

    const hasSuccess = results.some((res) => res.status === 'success');

    if (hasSuccess) {
      if (isModal && closeModal) {
        const reqBody = {
          eventId: currentEvent?.id as number,
          page: 1,
          pageSize: isLaptop ? defaultPageSize : 10000,
        };
        await dispatch(getAuctionWonList({id: +currentEvent?.id, reqBody})).unwrap();
        closeModal();
      }

      toast.success('Winner added successfully');
      navigate(`${ROUTER_URL.ORGANIZATION_AUCTION_ENTRY}`);
    }
  };

  return (
    <Box style={{width: '100%'}}>
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={handleAddWinnerSubmit}
        validateOnBlur={true}
        validateOnChange={false}
      >
        <AddWinnerForm />
      </Formik>
    </Box>
  );
};

export default AddWinnerPage;
